// Chart colors for communities
export const COMMUNITY_COLORS = [
  "#f85149",
  "#58a6ff",
  "#ffa657",
  "#a371f7",
  "#3fb950",
  "#ff7b72",
  "#79c0ff",
  "#ffa198",
  "#bc8cff",
  "#56d364",
] as const;

// Chart configuration
export const CHART_CONFIG = {
  strokeWidth: 2,
  gridStroke: "#30363d",
  axisStroke: "#8b949e",
  tooltipStyle: {
    background: "#161b22",
    border: "1px solid #30363d",
    borderRadius: "6px",
    color: "#e4e7eb",
  },
  // Animation settings - duration only, isAnimationActive computed dynamically
  animation: {
    duration: 300,
  },
  // Threshold for disabling animations (too many points = laggy)
  animationThreshold: 300,
} as const;

// Helper to determine if animations should be enabled based on data size
export function shouldAnimate(dataPointCount: number): boolean {
  return dataPointCount <= CHART_CONFIG.animationThreshold;
}

// Energy thresholds (percentage)
export const ENERGY_THRESHOLDS = {
  danger: 95,
  warning: 90,
} as const;

// Capacity limits (MW). Defined in src/lib/capacity.ts so the report can measure
// headroom against exactly the figures these gauges display.
export { CAPACITY } from '../lib/capacity';

// Refresh intervals (milliseconds)
export const REFRESH_INTERVALS = {
  current: 60000,
  historical: 60000,
} as const;

// Date constraints
export const DATE_CONSTRAINTS = {
  minDate: "2025-12-05T00:00",
  defaultRangeHours: 24,
} as const;

// Halifax timezone
export const TIMEZONE = "America/Halifax" as const;

/**
 * Report palette. Validated for the dark chart surface (#161b22) against the
 * lightness band, chroma floor, colourblind separation, normal-vision floor and
 * contrast. Green is deliberately absent: against this orange it collapses to
 * ΔE 1.8 under protanopia, so identity would be lost for red-blind readers.
 * Assign these by entity and never by rank.
 */
export const REPORT_COLORS = {
  imported: "#388bfd",
  fossil: "#db6d28",
  renewable: "#8957e5",
  /** Renewable power leaving the island — validated as a fourth categorical slot. */
  exported: "#17a2a2",
  /** Single-series magnitude bars (band charts). */
  magnitude: "#388bfd",
} as const;
